import { Button, Typography } from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import { sendTag } from "../../analytics";
import { COMPANY_CREATION_URL } from "../../constants";
import styled from "styled-components";

type Props = {
  organizationIdentifier: string | undefined;
};

const CompanyCreationAuthExpired = ({ organizationIdentifier }: Props) => {
  const { t } = useTranslation();
  sendTag({ status: "authExpired" });

  const handleContinue = () => {
    // organizationIdentifier must be passed to /v1/login so Telia's callback can attach it as a claim; without it the order controller rejects with 401 again.
    const url = organizationIdentifier
      ? `${COMPANY_CREATION_URL}/v1/login?organizationIdentifier=${encodeURIComponent(organizationIdentifier)}`
      : `${COMPANY_CREATION_URL}/v1/login`;
    window.location.href = url;
  };

  return (
    <>
      <CenteredTypography variant="headingH4Regular">
        {t("OnlineStatus.AuthExpiredTitle")}
      </CenteredTypography>
      <CenteredPrimaryTypography color="primary">
        {t("OnlineStatus.AuthExpiredDescription")}
      </CenteredPrimaryTypography>
      <ButtonContainer>
        <Button onClick={handleContinue}>
          {t("OnlineStatus.Continue")}
        </Button>
      </ButtonContainer>
    </>
  );
};

export default CompanyCreationAuthExpired;

const CenteredTypography = styled(Typography)`
  text-align: center;
  margin-top: 24px;
`;

const CenteredPrimaryTypography = styled(Typography)`
  text-align: center;
  padding-top: 24px;
  margin-left: 20%;
  margin-right: 20%;

  @media (max-width: 768px) {
    margin-left: 5%;
    margin-right: 5%;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;
